/**
 * Canonical support contact.
 *
 * There is deliberately no `/support` route — email is the real channel. Link
 * to `supportMailto()` rather than hardcoding an address, so the destination
 * changes in one place.
 *
 * Never put error text, stack traces, or record details into a mailto subject
 * or body: it leaves the app unredacted and can carry PHI.
 */

export const SUPPORT_EMAIL = 'support@mycasemgr.com';

/**
 * `mailto:` URL for the support address, optionally with a subject line to
 * give the reader context about where the user got stuck.
 */
export function supportMailto(subject?: string): string {
  return subject
    ? `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`
    : `mailto:${SUPPORT_EMAIL}`;
}
